import { getEnumBattlePassStatusName } from '../autogen/bundle.js';

import { getStrWithLowFirstLetter } from '../util.js';
import { getOptionalTextMomentStr } from '../util.js';
import { getDurationStr           } from '../util.js';
import { getDurationStrSimple     } from '../util.js';
import { isNumberSpecified        } from '../util.js';
import { isRoleAdmin              } from '../util.js';

/**
 * @typedef { import('../auth.js').Role } Role
 */

/**
 * @typedef {number} SeasonId
 */

export function convertSeasonTypeArrayToTypeNameMap(seasonTypeArray) {
  if(seasonTypeArray === undefined) {
    return null;
  }
  if(seasonTypeArray === null) {
    return null;
  }

  const typeNameMap = new Map();
  for(const seasonType of seasonTypeArray) {
    typeNameMap.set(seasonType.id, seasonType.name);
  }
  return typeNameMap;
}

export function getSeasonTypeNameFromMap(typeNameMap, seasonProtoId) {
  if(typeNameMap === null) {
    return getFallbackSeasonTypeName(seasonProtoId);
  }

  const name = typeNameMap.get(seasonProtoId);
  if(name === undefined) {
    return getFallbackSeasonTypeName(seasonProtoId);
  }
  return name;
}

function getFallbackSeasonTypeName(seasonProtoId) {
  if(seasonProtoId === undefined) {
    return 'Season proto ?';
  }
  return 'Season proto ' + seasonProtoId.toString();
}

/**
 * @typedef {number} SeasonStatus
 */

export const SEASON_STATUS_INCOMING = 1;
export const SEASON_STATUS_ACTIVE   = 2;
export const SEASON_STATUS_FINISHED = 3;

/**
 * @param {SeasonStatus} status
 * @returns {boolean}
 */
export function isSeasonIncoming(status) {
  return status === SEASON_STATUS_INCOMING;
}

/**
 * @param {SeasonStatus} status
 * @returns {boolean}
 */
export function isSeasonActive(status) {
  return status === SEASON_STATUS_ACTIVE;
}

export function isSeasonForQA(qaStatus) {
  return qaStatus === 1;
}

export function getSeasonStatusName(status) {
  const name = getEnumBattlePassStatusName(status);
  return getStrWithLowFirstLetter(name);
}

export function getSeasonStatusNameRu(status) {
  switch(status) {
    case SEASON_STATUS_INCOMING: return 'запланирован';
    case SEASON_STATUS_ACTIVE:   return 'активен';
    case SEASON_STATUS_FINISHED: return 'завершен';
  }

  return 'Неизвестный статус ' + status;
}

export function getSeasonStatusClass(status) {
  return {
    activeSeason: isSeasonActive(status),
  };
}

export function getSeasonForQAClass(for_qa) {
  return {
    activeSeason: isSeasonForQA(for_qa),
  };
}

export function getSeasonRealStartTimeStr(time) {
  return getOptionalTextMomentStr(time, '---'); // не началось
}

export function getSeasonRealFinishTimeStr(time) {
  return getOptionalTextMomentStr(time, '---'); // не завершено
}

export function getSeasonRemainingTimeStr(season, nowSec) {
  if(season.status === SEASON_STATUS_INCOMING) {
    return '---'; // не началось
  }

  if(season.status === SEASON_STATUS_FINISHED) {
    return '---'; // завершено
  }

  const timeEnded = nowSec >= season.ftime;
  if(timeEnded) {
    return 'time ended';
  }

  const remainintTime = season.ftime - nowSec;
  return getDurationStrSimple(remainintTime);
}

export function getSeasonPlannedDuration(season) {
  return season.ftime - season.stime;
}

export function getSeasonRealDuration(season) {
  return season.frtime - season.srtime;
}

export function getSeasonPlannedDurationStr(season) {
  const plannedDuration = getSeasonPlannedDuration(season);
  return getDurationStr(plannedDuration);
}

export function getSeasonRealDurationStr(season) {
  if(!isNumberSpecified(season.srtime)) {
    return 'not started';
  }
  if(!isNumberSpecified(season.frtime)) {
    return 'not finished';
  }
  const realDuration = getSeasonRealDuration(season);
  return getDurationStr(realDuration);
}

export function getSeasonRealDurationStrSimple(season) {
  if(!isNumberSpecified(season.srtime)) {
    return 'not started';
  }
  if(!isNumberSpecified(season.frtime)) {
    return 'not finished';
  }
  const realDuration = getSeasonRealDuration(season);
  return getDurationStrSimple(realDuration);
}

//-----------------------------------------------------------------------------

// Return true, if user may do any action with game event.
export function mayManageSeasons(role) {
  if(mayStartSeason(role)) {
    return true;
  }
  if(mayForceStartSeason(role)) {
    return true;
  }
  if(mayFinalizeSeason(role)) {
    return true;
  }
  if(mayDeleteSeason(role)) {
    return true;
  }
  return false;
}

export function mayStartSeason(role) {
  return isRoleAdmin(role);
}

export function mayForceStartSeason(role) {
  return isRoleAdmin(role);
}

export function mayFinalizeSeason(role) {
  return isRoleAdmin(role);
}

export function mayDeleteSeason(role) {
  return isRoleAdmin(role);
}

//-----------------------------------------------------------------------------

/**
 * @param {Role} userRole
 * @param {SeasonStatus} seasonStatus
 * @returns {boolean}
 */
export function canUserEditCorrection(userRole, seasonStatus) {
  const isAdmin = isRoleAdmin(userRole);
  if(!isAdmin) {
    return false;
  }

  return isCorrectionEditable(seasonStatus);
}

/**
 * @param {SeasonStatus} status
 * @returns {boolean}
 */
function isCorrectionEditable(status) {
  return isSeasonIncoming(status) || isSeasonActive(status);
}